/**
 * @generated SignedSource<<63680cbddff062a938adac3615bc7526>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAssignmentRuleInput = {
  assignmentRuleId: string;
  clientMutationId?: string | null;
};
export type licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation$variables = {
  input: DeleteAssignmentRuleInput;
};
export type licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation$data = {
  readonly LicenseManagement: {
    readonly deleteAssignmentRule: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation = {
  response: licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation$data;
  variables: licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LicenseManagementMutations",
    "kind": "LinkedField",
    "name": "LicenseManagement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "DeleteAssignmentRulePayload",
        "kind": "LinkedField",
        "name": "deleteAssignmentRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf2bcd028c5df9d246642ddd30575ab1",
    "id": null,
    "metadata": {},
    "name": "licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation",
    "operationKind": "mutation",
    "text": "mutation licensesSingleUserAssignmentCard_deleteSingleUserAssignmentRuleMutation(\n  $input: DeleteAssignmentRuleInput!\n) {\n  LicenseManagement {\n    deleteAssignmentRule(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c319c57dfed850870341e40709d23bb4";

export default node;
